import { MessageCircle } from 'lucide-react';
import { siteConfig } from '@/data/site';
import { buildGeneralWhatsAppMessage, buildWhatsAppUrl, cn } from '@/utils';
import { trackEvent } from '@/services/analytics';

interface WhatsAppButtonProps {
  message?: string;
  context?: string;
  className?: string;
}

export function WhatsAppButton({ message, context = 'floating', className }: WhatsAppButtonProps) {
  const phone = siteConfig.contact.whatsapp;

  if (!phone) {
    if (import.meta.env.DEV) {
      return (
        <div
          className="fixed bottom-6 right-6 z-40 rounded-lg bg-yellow-100 px-3 py-2 text-xs text-yellow-800 shadow-lg"
          aria-hidden="true"
        >
          TODO: WhatsApp
        </div>
      );
    }
    return null;
  }

  const url = buildWhatsAppUrl(phone, message ?? buildGeneralWhatsAppMessage());

  const handleClick = () => {
    void trackEvent('whatsapp_clicked', { context });
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={cn(
        'fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-whatsapp',
        className,
      )}
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="h-7 w-7" aria-hidden="true" />
    </a>
  );
}
